module.exports = __webpack_public_path__ + "img/close-eye.44039558.svg";